import React from "react";

const DatePicker = (props) => {
  const {
    date,
    setDate,
    name,type,
    id,
    label,
    labelStyle,
    inputStyle,
    placeholder,
    isRequired,
    minDate = "",
    maxDate = "",
  } = props;


  console.log({date, label});
  return (
    <>
    {
      label!==undefined && 
    
      <label htmlFor={id} style={labelStyle} className="form-label mb-0">
        {label}:{isRequired && <span className="text-danger">*</span>}
      </label>
}
      <input
        type={type  || "date"}
        className="form-control"
        id={id}
        style={inputStyle}
        name={name}
        placeholder={placeholder}
        onChange={(e) => {
          setDate(e.target.value);
        }}
        value={date}
        required={isRequired}
        min={minDate}
        max={maxDate}
      />
    </>
  );
};

export default DatePicker;
